const voucherTypes = [
    { label: 'Internal', value: 'internal' },
    { label: 'External', value: 'external' },
    { label: 'E-Guma', value: 'eguma' },
];

export default voucherTypes;
